import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  cleanAll,
  editUserById,
  getAll,
} from "../../store/reducers/userReducer";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  FlexRowBetween,
  Input,
  ListHolder,
  PlaceHolderImage,
  RespFont,
  TextWithPic,
  UserCard,
} from "../common/Style";
import {
  dateFormat,
  days,
  exportToCSV,
  handleClickScroll,
} from "../common/others/Functions";
import FilledLoading from "../common/loader/FilledLoading";
import EditUser from "./EditUser";
import GenericModal from "../common/modals/GenericModal";
import tools from "../../assets/common/menu.svg";
import logout from "../../assets/common/logout.svg";
import clear from "../../assets/common/clear.svg";
import plus from "../../assets/common/plus.svg";
import arrowUp from "../../assets/common/arrowUp.svg";
import arrowDown from "../../assets/common/arrowDown.svg";

import LogoutSpecipic from "../common/LogOut/LogoutSpecipic";
import BottomMenu from "../common/others/BottomMenu";
import ToolsOptions from "../user/ToolsOptions";
import ClientRoutes from "../../navigation/Routes";
import { useHistory } from "react-router-dom";
import TalsPayments from "./TalsPayments";
import AddUser from "./AddUser";

const MainAdmin = () => {
  const [searchText, setSearchText] = useState("");
  const inputRef = useRef();

  let history = useHistory();
  const { users } = useSelector((state) => state.userReducer);
  const { user } = useSelector((state) => state.authReducer);
  const [loading, setLoading] = useState(false);
  const [user2edit, setUser2edit] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showTals, setShowTals] = useState(false);
  const [showAddUser, setShowAddUser] = useState(false);

  const dispatch = useDispatch();

  const handleGetAllAfterAdd = async () => {
    setShowAddUser(false);
    handleGetAll();
  };

  // const ff = (id) => {
  //   dispatch(editUserById(id, { isReadyAdmin: false })).then((res) => {
  //     if (!res.payload?.error) {
  //       toast.success("הפעולה בוצעה בהצלחה");
  //     } else toast.error(res.payload?.error);
  //   });
  // };

  const handleGetAll = async () => {
    setLoading(true);
    dispatch(getAll()).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      setLoading(false);
    });
  };

  useEffect(() => {
    handleGetAll();
    return () => {
      dispatch(cleanAll());
    };
  }, []);

  useEffect(() => {
    setTimeout(function () {
      handleClickScroll("bla");
    }, 1000);
  }, []);

  let guestsArray = useMemo(() => {
    let arr = [];
    let money = [];
    let sortedArr = [];
    if (Object.keys(users).length > 0)
      for (const [key, value] of Object.entries(users))
        if (
          searchText
            .toLowerCase()
            .split(" ")
            .filter((i) =>
              value.brideFN?.toLowerCase().includes(i.toLowerCase())
            ).length === searchText.toLowerCase().split(" ").length ||
          searchText
            .toLowerCase()
            .split(" ")
            .filter((i) =>
              value.groomFN?.toLowerCase().includes(i.toLowerCase())
            ).length === searchText.toLowerCase().split(" ").length ||
          searchText
            .toLowerCase()
            .split(" ")
            .filter((i) =>
              value.calendarName?.toLowerCase().includes(i.toLowerCase())
            ).length === searchText.toLowerCase().split(" ").length ||
          value.phone.includes(searchText) ||
          searchText === ""
        )
          sortedArr.push(value);
    let date = new Date();
    date.setHours(3);
    date.setMinutes(0);
    date.setSeconds(0);
    sortedArr.push({
      calendarName: "blablabla",
      date: date.toISOString(),
    });
    sortedArr.sort((a, b) => new Date(a["date"]) - new Date(b["date"]));

    for (let i = 0; i < sortedArr.length; i++) {
      if (sortedArr[i].calendarName === "blablabla")
        arr.push(
          <FlexRowBetween
            key={"bookmark"}
            style={{
              backgroundColor: "#7b96c4",
              height: "3px",
              marginTop: "10px",
            }}
            id={"bla"}
          />
        );
      else {
        if (
          sortedArr[i].seatupEventId == "besimple" &&
          sortedArr[i].producer.toLowerCase() != "callup"
        )
          if (!user.isItay) continue;
        money.push({
          תאריך: dateFormat(sortedArr[i].date),
          שולם: sortedArr[i].isPaid ? "כן" : "לא",
          "מס׳ נייד": sortedArr[i].phone,
          דיל: sortedArr[i].deal,
          חברה: sortedArr[i].producer,
          אולם: sortedArr[i].hall,
          רשומות: sortedArr[i].records,
          שיחות:
            parseFloat(sortedArr[i].restRecordsAtFirstCall) * parseFloat(1.2),
          סמס: parseFloat(
            parseFloat(0.01 * sortedArr[i].smsCounter * 1.17).toFixed(2)
          ),
          ווצאפ: parseFloat(
            parseFloat(0.17 * sortedArr[i].whaCounter * 1.17).toFixed(2)
          ),
          אשראי: sortedArr[i].paybox.length > 1 ? "כן" : "לא",
          עמלות: sortedArr[i].payboxTax,
          הערות: sortedArr[i].description,
        });
        arr.push(
          <UserCard
            border={
              sortedArr[i].isPaid
                ? "#7b96c4"
                : days(new Date(), new Date(sortedArr[i].date)) >= 1
                ? "#ec7070"
                : "none"
            }
            borderR={
              sortedArr[i].seatupEventId == "besimple" &&
              sortedArr[i].producer !== "CallUp"
                ? "rgba(177, 141, 224, 0.9)"
                : "none"
            }
            style={{
              borderBottom:
                sortedArr[i].producer == "CallUp" &&
                sortedArr[i].restRecordsAtFirstCall == 0
                  ? "2px solid black"
                  : "none",
            }}
            key={i}
            onClick={() => setUser2edit(sortedArr[i])}
            // onClick={() => ff(sortedArr[i]._id)}
          >
            {/* <RespFont>{sortedArr[i].producer}</RespFont> */}
            <RespFont>
              {sortedArr[i].eventType
                ? `${sortedArr[i].brideFN} ${sortedArr[i].brideLN} ו${sortedArr[i].groomFN} ${sortedArr[i].groomLN}`
                : sortedArr[i].calendarName}
            </RespFont>
            <RespFont
              style={{
                background: sortedArr[i].description.includes("דיילות - שוריין")
                  ? "rgba(145, 224, 141, 0.9)"
                  : sortedArr[i].description.includes("דיילות")
                  ? "#f48c8c"
                  : "inherit",
              }}
            >
              {dateFormat(
                sortedArr[i].hour1 === ""
                  ? "אין פרטים"
                  : sortedArr[i].hour1 + ", " + sortedArr[i].hall
              )}
            </RespFont>
            <RespFont>{dateFormat(sortedArr[i].date)}</RespFont>
            {/* <RespFont>{value.xxx}</RespFont> */}
          </UserCard>
        );
      }
    }

    return [arr, money];
  }, [users, searchText]);

  let dataArr = null;
  if (user.isItay !== undefined && user.isItay === true)
    dataArr = [
      <img
        key={1}
        src={tools}
        alt="tools"
        style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
        onClick={() => setShowMenu(true)}
      />,
    ];

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
      }}
    >
      {/* <div
        onClick={() => handleClickScroll("top")}
        style={{
          width: "min-content",
          boxShadow:
            "0 2px 2px rgba(0, 0, 0, 0.11), 0 -2px 2px rgba(0, 0, 0, 0.11)",
          borderRadius: "50px",
          padding: "5px",
          fontWeight: "700",
          cursor: "pointer",
          position: "fixed",
          top: "10px",
          left: "10px",
          zIndex: 2,
        }}
      >
        <div
          style={{
            padding: "2px 2px",
            backgroundColor: "#7b96c4",
            transition: "all 0.2s",
            borderRadius: "50px",
            width: "max-content",
          }}
        >
          <img src={arrowUp} alt="arrowUp" style={{ width: "25px" }} />
        </div>
      </div>
      <div
        onClick={() => handleClickScroll("bla")}
        style={{
          width: "min-content",
          boxShadow:
            "0 2px 2px rgba(0, 0, 0, 0.11), 0 -2px 2px rgba(0, 0, 0, 0.11)",
          borderRadius: "50px",
          padding: "5px",
          fontWeight: "700",
          cursor: "pointer",
          position: "fixed",
          top: "70px",
          left: "10px",
        }}
      >
        <div
          style={{
            padding: "2px 2px",
            backgroundColor: "#7b96c4",
            transition: "all 0.2s",
            borderRadius: "50px",
            width: "max-content",
          }}
        >
          <img src={arrowDown} alt="arrowDown" style={{ width: "25px" }} />
        </div>
      </div> */}
      <BottomMenu
        data={[
          // <img
          //   key={1}
          //   src={tools}
          //   alt="tools"
          //   style={{ width: "31px", padding: "10px 0" }}
          //   onClick={() => setShowMenu(true)}
          // />,
          // <img
          //   key={2}
          //   src={plus}
          //   alt="plus"
          //   style={{ width: "31px", padding: "10px 0" }}
          //   onClick={() => setShowAddOptions(true)}
          // />,
          dataArr,

          <img
            key={2}
            src={plus}
            alt="plus"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowAddUser(true)}
          />,
          <img
            key={3}
            src={logout}
            alt="logout"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowLogout(true)}
          />,
        ]}
      />
      <div id="top"></div>
      <FlexRowBetween
        style={{
          background: "#f2f2f2",
          padding: "10px 10px",
          position: "fixed",
          boxShadow: "0 2px 4px #b3b2b2",
          // width: "70%",
          // marginRight: "0px",
        }}
      >
        <div
          // id="top"
          style={{
            position: "relative",
            // marginRight: "5px",
            // marginTop: "5px",
            width: "150px",
          }}
        >
          <PlaceHolderImage
            onClick={() => {
              setSearchText("");
              inputRef.current.focus();
            }}
            fontSize={`28px`}
            top={`50%`}
            src={clear}
            alt="clear"
            style={{
              cursor: "pointer",
              border: "1px solid silver",
              padding: "5px",
              borderRadius: "2px",
              left: "7px",
            }}
          />
          <Input
            value={searchText}
            ref={inputRef}
            type="text"
            placeholder="חיפוש"
            name="value"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              padding: "7px 0px",
              paddingRight: "3px",
              border: "1px solid silver",
            }}
            // let tempPhone = phone.replaceAll(/[^\d]/g, "");
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div onClick={() => exportToCSV(guestsArray[1], "כללי")}>כספים</div>
        <div
          onClick={() => handleClickScroll("top")}
          style={{
            width: "min-content",
            boxShadow:
              "0 2px 2px rgba(0, 0, 0, 0.11), 0 -2px 2px rgba(0, 0, 0, 0.11)",
            borderRadius: "50px",
            padding: "5px",
            fontWeight: "700",
            cursor: "pointer",
            // position: "fixed",
            // top: "10px",
            // left: "10px",
            // zIndex: 2,
          }}
        >
          <div
            style={{
              padding: "2px 2px",
              backgroundColor: "#7b96c4",
              transition: "all 0.2s",
              borderRadius: "50px",
              width: "max-content",
            }}
          >
            <img src={arrowUp} alt="arrowUp" style={{ width: "25px" }} />
          </div>
        </div>
        <div
          onClick={() => handleClickScroll("bla")}
          style={{
            width: "min-content",
            boxShadow:
              "0 2px 2px rgba(0, 0, 0, 0.11), 0 -2px 2px rgba(0, 0, 0, 0.11)",
            borderRadius: "50px",
            padding: "5px",
            fontWeight: "700",
            cursor: "pointer",
            // position: "fixed",
            // top: "70px",
            // left: "10px",
          }}
        >
          <div
            style={{
              padding: "2px 2px",
              backgroundColor: "#7b96c4",
              transition: "all 0.2s",
              borderRadius: "50px",
              width: "max-content",
            }}
          >
            <img src={arrowDown} alt="arrowDown" style={{ width: "25px" }} />
          </div>
        </div>
      </FlexRowBetween>
      <ListHolder style={{ marginTop: "70px", paddingBottom: "70px" }}>
        {guestsArray[0]}
      </ListHolder>
      {loading && <FilledLoading />}

      {user2edit && (
        <GenericModal
          init={setUser2edit}
          div={<EditUser user={user2edit} init={setUser2edit} />}
        />
      )}

      {showAddUser && (
        <GenericModal
          init={setShowAddUser}
          div={<AddUser init={handleGetAllAfterAdd} />}
        />
      )}

      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}

      {showTals && (
        <GenericModal
          init={setShowTals}
          div={<TalsPayments init={setShowTals} />}
        />
      )}

      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                // <TextWithPic
                //   key={1}
                //   onClick={() => history.push(ClientRoutes.Admin.main)}
                // >
                //   ראשי
                // </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.Admin.avivit)}
                  key={5}
                >
                  אביבית
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.Admin.news)}
                  key={6}
                >
                  חדשים
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.Admin.todos)}
                  key={1}
                >
                  משימות
                </TextWithPic>,
                <TextWithPic onClick={() => setShowTals(true)} key={2}>
                  משכורת
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.Admin.msg)}
                  key={3}
                >
                  הודעות
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.Admin.guests)}
                  key={4}
                >
                  אורחים
                </TextWithPic>,
              ]}
            />
          }
        />
      )}
    </div>
  );
};

export default MainAdmin;
